import { render, staticRenderFns } from "./ProgramMetricWidget.vue?vue&type=template&id=1fc6a845&scoped=true"
import script from "./ProgramMetricWidget.vue?vue&type=script&lang=js"
export * from "./ProgramMetricWidget.vue?vue&type=script&lang=js"
import style0 from "./ProgramMetricWidget.vue?vue&type=style&index=0&id=1fc6a845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc6a845",
  null
  
)

export default component.exports